import { columnTypes } from '../../constants/globals';
import { loginResponseStatus } from './audit-events-utils';

export const tableConfig = () => {
  const {
    AUTHENTICATION_SUCCESS,
    AUTHENTICATION_FAILURE,
    AUTHORIZATION_FAILURE,
  } = loginResponseStatus || {};

  return {
    columns: [
      {
        key: 'timestamp',
        width: '',
        className: 'text-center',
        type: columnTypes.date,
        timestamp: true,
      },
      {
        key: 'type',
        width: '',
        className: 'text-center',
        type: columnTypes.enum,
        options: [
          {
            text: (
              <label className="text-success">{AUTHENTICATION_SUCCESS}</label>
            ),
            value: AUTHENTICATION_SUCCESS,
          },
          {
            text: (
              <label className="text-danger bold-text">
                {AUTHENTICATION_FAILURE}
              </label>
            ),
            value: AUTHENTICATION_FAILURE,
          },
          {
            text: (
              <label className="text-danger bold-text">
                {AUTHORIZATION_FAILURE}
              </label>
            ),
            value: AUTHORIZATION_FAILURE,
          },
        ],
      },
      {
        key: 'principal',
        width: '',
        className: 'text-center',
        type: columnTypes.value,
      },
    ],
  };
};
